import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { isMobile } from "../../../constants/css";

class SidebarItem extends Component {
  render() {
    return (
      <li
        className="main-sidebar__item"
        onClick={() => {
          if (isMobile()) {
            this.props.toggleSidebar();
          }
        }}>
        <NavLink
          className="main-sidebar__link"
          to={this.props.route}
          activeClassName="main-sidebar__link--active">
          {this.props.label}
        </NavLink>
      </li>
    );
  }
}

export default SidebarItem;
